import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { api, errorText, fmtTime } from "@/lib/api";

const TONE = { approved: "text-emerald-300", pending: "text-amber-300", rejected: "text-rose-300" };

export const MspsPanel = () => {
  const [rows, setRows] = useState([]);
  const load = () => api.get("/admin/msps").then((r) => setRows(r.data)).catch((e) => toast.error(errorText(e)));
  useEffect(() => { load(); }, []);

  const setStatus = async (m, status) => {
    try { await api.post(`/admin/msps/${m.id}/status`, { status }); toast.success(`${m.company} ${status}`); load(); } catch (e) { toast.error(errorText(e)); }
  };

  return (
    <section className="space-y-4">
      <p className="text-sm text-slate-400">MSPs who applied to the partner program. Their branded sign-up link only works once approved. MSP sign-up page: <a href="/msp/signup" className="text-emerald-400">/msp/signup</a></p>
      {!rows.length ? <p className="rounded-md border border-dashed border-[#222D3D] p-8 text-center text-sm text-slate-500" data-testid="msps-empty">No MSP applications yet.</p> : (
        <div className="rounded-md border border-[#222D3D] bg-[#0F141C] overflow-x-auto" data-testid="msps-table">
          <Table>
            <TableHeader><TableRow className="border-[#222D3D] hover:bg-transparent">
              {["MSP", "Applied", "Properties", "Status", ""].map((h, i) => <TableHead key={i} className="text-[11px] uppercase tracking-[0.14em] text-slate-500">{h}</TableHead>)}
            </TableRow></TableHeader>
            <TableBody>
              {rows.map((m) => (
                <TableRow key={m.id} className="border-[#222D3D] hover:bg-[#141A24]" data-testid={`msp-row-${m.email}`}>
                  <TableCell><p className="text-slate-100">{m.company}</p><p className="text-xs text-slate-500">{[m.name, m.email, m.phone].filter(Boolean).join(" · ")}</p>
                    {m.status === "approved" && <p className="font-mono text-[11px] text-slate-500 mt-1">/p/{m.slug}</p>}</TableCell>
                  <TableCell className="font-mono text-xs text-slate-400 whitespace-nowrap">{fmtTime(m.created_at)}</TableCell>
                  <TableCell className="font-mono text-sm">{m.properties}</TableCell>
                  <TableCell className={`font-mono text-xs capitalize ${TONE[m.status]}`} data-testid={`msp-status-${m.email}`}>{m.status}</TableCell>
                  <TableCell className="text-right whitespace-nowrap space-x-2">
                    {m.status !== "approved" && <Button size="sm" onClick={() => setStatus(m, "approved")} className="bg-emerald-500 hover:bg-emerald-400 text-[#07090E]" data-testid={`msp-approve-btn-${m.email}`}>Approve</Button>}
                    {m.status !== "rejected" && <Button size="sm" variant="outline" onClick={() => setStatus(m, "rejected")} className="border-[#222D3D] bg-transparent" data-testid={`msp-reject-btn-${m.email}`}>{m.status === "approved" ? "Revoke" : "Reject"}</Button>}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      )}
    </section>
  );
};
